import type { SveaRequestInit } from "./types";

export class InvalidRevisionError extends Error {
	readonly #request?: {
		url: string;
		init?: SveaRequestInit;
	};

	constructor(message?: string, url?: string, init?: SveaRequestInit) {
		super(message);
		this.name = "InvalidRevisionError";
		if (url) {
			this.#request = {
				url,
				init,
			};
		}
	}

	get request() {
		return this.#request;
	}
}
